import { Box } from "@mui/material";
import image from "../../../src/assets/images/invite_edit.png";
import styles from "./home.module.scss";


const Home = () => {
  return (
    <Box display="flex"
    justifyContent="center"
    alignItems="center" 
    className={styles['image-box-container']}>
      <img className={styles["invitation-card"]} src={image} alt="whoopsie"/>
    </Box>
  );
};

export default Home;
